import ava1 from '../assets/ava1.png';
import ava2 from '../assets/ava2.png';
import ava3 from '../assets/ava3.png';
import folder1 from '../assets/folder-a.svg';
import folder2 from '../assets/folder-b.svg';
import folderFilled from "../assets/folder_filled.svg";
import mockVertical from "../assets/mockImages/mockVertical.jpg";
import mockHorizontal from "../assets/mockImages/mockHorizontal.jpg";
import { IAnalysisFolder } from '../pages/dashboardPage/components/fullAnalysis/IAnalysisFolder';

export const clients = [
    {
        name: 'Tony Soprano',
        date1: 'WED 12:34',
        date2: 'FRI 56:23',
        avatarUrl: ava1
    },
    {
        name: 'Laur Somey',
        date1: 'WED 42:34',
        date2: 'FRI 56:18',
        avatarUrl: ava2
    },
    {
        name: 'Maria Holon',
        date1: 'WED 12:24',
        date2: 'FRI 36:23',
        avatarUrl: ava3
    }
];

export const tasks = [
    {
        title: 'Load file',
        text: 'More text about file loading',
        label: 'file',
        checked: false
    },
    {
        title: 'Read a transcription',
        text: 'Transcription for the last session is ready. Read it to see a new tips and patterns!',
        label: 'tips',
        checked: false
    },
];

export const sessions = [
    {
        date: 'Friday, 27.07',
        status: 'Upcoming',
        video: '',
    },
    {
        date: 'Wednesday, 17.07',
        status: 'Finished',
        video: '1',
    },
    {
        date: 'Monday, 11.07',
        status: 'Cancelled',
    }
];

export const folders = [
    {
        name: 'Folder name',
        date: '12 Sep',
        avatarUrl: folder1
    },
    {
        name: 'Another one',
        date: '24 Aug',
        avatarUrl: folder2
    }
];

export const foldersRoot: IAnalysisFolder = {
    id: '1',
    name: 'Analysis',
    date: new Date(),
    avatarUrl: folder1,
    type: 'folder',
    folderItems: [
        {
            id: '2',
            folderItems: [
                {
                    id: '3',
                    fileData: [
                        {
                            name: 'Tony Soprano',
                            tags: ['client'],
                            date: '12:34',
                            action: 'A note you added from the 21.06 session',
                            chunks: [
                                {
                                    type: 'quote',
                                    data: {
                                        title: 'Disappointment in School: ',
                                        text: 'When I brought home a bad grade in middle school, my dad barely said anything. He just gave me this look of disappointment, like I let him down. I remember feeling really small, like I wasn\'t good enough.'
                                    }
                                },
                                {
                                    type: 'photos',
                                    data: {
                                        photos: [mockVertical, mockHorizontal]
                                    }
                                },
                                {
                                    type: 'notes',
                                    data: {
                                        iconUrl: folderFilled,
                                        title: 'Father',
                                        date: 'Last edited just now'
                                    }
                                },
                            ],
                        }
                    ],
                    name: 'File1',
                    date: new Date(),
                    type: 'file',
                    iconIndex: 0
                }
            ],
            name: 'Folder name',
            date: new Date(),
            avatarUrl: folder1,
            type: 'folder'
        },
        {
            id: '4',
            folderItems: [
                {
                    id: '5',
                    folderItems: [],
                    name: 'Nested one',
                    date: new Date(),
                    iconIndex: 0,
                    type: 'folder'
                },
                {
                    id: '6',
                    folderItems: [],
                    name: 'Another nested',
                    date: new Date(),
                    iconIndex: 0,
                    type: 'folder'
                }
            ],
            name: 'Another one',
            date: new Date(),
            avatarUrl: folder1,
            type: 'folder'
        }
    ]
};

export const bottomMenu = [
    {
        name: 'Sessions',
        show: true,
    },
    {
        name: 'Chat',
        show: false,
    },
    {
        name: 'Calendar',
        show: true
    },
    {
        name: 'Lifeline',
        show: true
    },
    {
        name: 'Analysis',
        show: true
    },
    {
        name: 'Tasks',
        show: true
    },
    {
        name: "Notes",
        show: true,
    },
    {
        name: 'Mindmap',
        show: true
    },
    {
        name: 'Statistic',
        show: true
    }
];

export type BottomMenuItems = '' | 'Sessions' | 'Notes' | 'Chat' | 'Calendar' | 'Lifeline' | 'Analysis' | 'Tasks' | 'Statistic' | 'Mindmap' | 'Treatment plan';

export const leftMenu = [
    'All clients',
    'Schedule'
]